<template>
  <pt-adult-out-stock class="pt-adult-out-stock__withData"></pt-adult-out-stock>
</template>

<script>
import PtAdultOutStock from './index'
export default {
  name: 'pt-adult-out-stock__withData',
  components: {
    'pt-adult-out-stock': PtAdultOutStock
  }
}
</script>
